/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/15/2023
 *
 */

import React from 'react';
import '../Partner/partner.css';
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";
import Loader from "../../components/generic/loader/loader";
import API from "../../utils/api";

// get table configurations
const table = tableConfigs.toolProviders;

class ToolProviders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDisplayLoader: true,
            count: 0,
            // user token
            token: ''
        }

        EventEmitter.emit('setPageHeaderData', {
            page: 'toolProviders',
            pageName: "Tool Providers",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/toolProviders",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    componentDidMount = () => {
        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);
        oldState.token = token;
        oldState.isDisplayLoader = false;

        this.setState(oldState);
    }

    /**
     * handle the form submission
     */
    handleSubmit = async () => {
        const newState = Object.assign({}, this.state);
        newState.isDisplayLoader = true;

        this.setState(newState);

        await API.post('/tool_provider',
            {
                "lmsId": null,
                "allEnabled": true
            }, {headers: {Authorization: this.state.token}}
        ).then(response => {
            newState.isDisplayLoader = false;
            this.setState(newState, () => {
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            });
            this.setAlert("Success", "Success", "Successfully updated all LMS");
        }).catch(er => {
            newState.isDisplayLoader = false;
            this.setState(newState);
            this.displayErrorsForAPICalls(er);

        });
    };

    /**
     * fire an alert
     * @param alertType
     * @param alertTitle
     * @param alertMessage
     */
    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    displayErrorsForAPICalls = (error) => {
        this.setAlert("Error", "Error", "Something went wrong");
    };

    render() {
        return(
            <div className={'page-mainLayout'}>
                {this.state.isDisplayLoader && <Loader/>}
                <Table tableConfig={table} routerProps={this.props} pathname={'toolProviders'} />
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Enable all LMS"
                       onClick={this.handleSubmit}>
                        <i className="fa fa-check-circle fa-lg icon-primary" />
                    </div>
                </div>
            </div>
        )
    }
}

export default ToolProviders;
